import bag from "../../ui/art/hud-buttons/bag.png";
import menu from "../../ui/art/hud-buttons/menu.png";

import { TOP_BUTTON_SIDE } from "./touch-slots.ts";

/**
 * The icons of the Bag and menu buttons on a touch page: original 32 by 32 art under `ui/art/hud-buttons/`, drawn one
 * icon pixel to one logical pixel in the touch action buttons' outline.
 */
export const BUTTON_ICONS = { bag, menu } as const;

/**
 * The button icons' side in logical pixels: the top row button's square.
 */
export const BUTTON_ICON_SIZE = TOP_BUTTON_SIDE;
